module.exports = __webpack_public_path__ + "img/background-app-shop.b3cc328a.jpg";